import AtriumApi from "api";

const tagsService = {
  // Get all tags for the organization
  getTags: async (params = {}) => {
    const { q, type, isActive, page = 1, per = 100 } = params;
    const queryParams = new URLSearchParams();

    if (q) queryParams.append('q', q);
    if (type) queryParams.append('type', type);
    if (isActive !== undefined) queryParams.append('isActive', isActive);
    queryParams.append('page', page);
    queryParams.append('per', per);

    const response = await AtriumApi.get(`/v1/tags?${queryParams.toString()}`);
    return response.data;
  },

  // Get a single tag by ID
  getTagById: async (tagId) => {
    const response = await AtriumApi.get(`/v1/tags/${tagId}`);
    return response.data;
  },

  // Create a new tag
  createTag: async (tagData) => {
    const response = await AtriumApi.post('/v1/tags', tagData);
    return response.data;
  },

  // Update a tag
  updateTag: async (tagId, tagData) => {
    const response = await AtriumApi.put(`/v1/tags/${tagId}`, tagData);
    return response.data;
  },

  // Delete (deactivate) a tag
  deleteTag: async (tagId, hard = false) => {
    const queryParams = hard ? '?hard=true' : '';
    const response = await AtriumApi.delete(`/v1/tags/${tagId}${queryParams}`);
    return response.data;
  },

  // Assign tag to users
  assignTagToUsers: async (tagId, userIds) => {
    const response = await AtriumApi.post(`/v1/tags/${tagId}/users`, { userIds });
    return response.data;
  },

  // Remove tag from user
  removeTagFromUser: async (tagId, userId) => {
    const response = await AtriumApi.delete(`/v1/tags/${tagId}/users/${userId}`);
    return response.data;
  },

  // Get all tags for a user
  getUserTags: async (userId) => {
    const response = await AtriumApi.get(`/v1/tags/users/${userId}/tags`);
    return response.data;
  },
};

export default tagsService;
